const calculateDaysDifference = (date1, date2) => {
  if (!date1 || !date2) return 0;
  const diffTime = date2.getTime() - date1.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

const PROCESS_CONFIG = {
  A: { name: "FUNDICION", normalDays: 5, fastDays: 3 },
  B: { name: "REPARTO INICIAL", normalDays: 1, fastDays: 1 },
  C: { name: "REPASO", normalDays: 3, fastDays: 2 },
  D: { name: "BOMBOS", normalDays: 2, fastDays: 1 },
  E: { name: "BAGGING COMPLETO", normalDays: null, fastDays: null },
  F: { name: "ENGASTADO", normalDays: 5, fastDays: 3 },
  G: { name: "PULIDO", normalDays: 3, fastDays: 2 },
  H: { name: "BAÑOS", normalDays: 2, fastDays: 1 },
  I: { name: "GRABADO", normalDays: 2, fastDays: 1 },
  J: { name: "CALIDAD", normalDays: 2, fastDays: 1 },
  K: { name: "CONTRASTE", normalDays: 1, fastDays: 1 },
  L: { name: "RECEPCIÓN PIEZA", normalDays: null, fastDays: null },
};

const PROCESS_ORDER = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];

const normalizeText = (text) => {
  if (!text) return "";
  return text
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

const PROCESS_MATCHING = {
  A: [
    { team: "fundicion", tipo: "Clasif." },
    { team: "fundicion", tipo: "Mecanizado." },
  ],
  B: [{ team: null, tipo: "ASIGNAR" }],
  C: [{ team: null, tipo: "REPASO" }],
  D: [{ team: null, tipo: "BOMBOS" }],
  E: [{ team: null, tipo: "Bagging Completo" }],
  F: [{ team: "engastado", tipo: "PIEDRAS" }],
  G: [{ team: null, tipo: "PULIDO" }],
  H: [{ team: null, tipo: "BAÑOS" }],
  I: [{ team: null, tipo: "GRABADO" }],
  J: [{ team: null, tipo: "CALIDAD" }],
  K: [{ team: null, tipo: "Contraste" }],
  L: [{ team: null, tipo: "Term." }],
};

const getProcessDateFromArray = (procesos, processCode) => {
  if (!procesos || !Array.isArray(procesos)) return null;
  
  const matchingRules = PROCESS_MATCHING[processCode];
  if (!matchingRules) return null;
  
  let earliestDate = null;
  
  for (const proceso of procesos) {
    const procesoTeam = normalizeText(proceso.team || "");
    const procesoTipo = normalizeText(proceso.tipo || "");
    
    for (const rule of matchingRules) {
      const ruleTeam = rule.team ? normalizeText(rule.team) : null;
      const ruleTipo = normalizeText(rule.tipo);

      const tipoMatches = procesoTipo === ruleTipo;
      const teamMatches = ruleTeam === null || procesoTeam === ruleTeam;

      let isValidMatch = false;
      if (processCode === "F") {
        isValidMatch = teamMatches && ruleTeam !== null;
      } else {
        isValidMatch = tipoMatches || (teamMatches && ruleTeam !== null && !tipoMatches);
      }

      if (isValidMatch) {
        const fecha = proceso.fecha_ini;
        if (fecha) {
          let processDate = null;
          
          if (typeof fecha === "object" && fecha.date) {
            processDate = new Date(fecha.date);
          } else if (typeof fecha === "string") {
            processDate = new Date(fecha);
          } else if (fecha instanceof Date) {
            processDate = fecha;
          }

          if (processDate && !isNaN(processDate)) {
            if (!earliestDate || processDate < earliestDate) {
              earliestDate = processDate;
            }
          }
        }
      }
    }
  }
  
  return earliestDate;
};

export const isFastOrder = (mo) => {
  const tipoOrden = normalizeText(mo.tipo_orden || "");
  const sevenDaysOrdersNormalized = normalizeText("SEVEN DAYS ORDERS");
  return tipoOrden === sevenDaysOrdersNormalized;
};

const findLastMarkedProcess = (procesos) => {
  const automaticProcesses = ["E", "L"];
  
  for (let i = PROCESS_ORDER.length - 1; i >= 0; i--) {
    const processCode = PROCESS_ORDER[i];
    
    if (automaticProcesses.includes(processCode)) {
      continue;
    }
    
    const processDate = getProcessDateFromArray(procesos, processCode);
    if (processDate) {
      return { processCode, date: processDate, index: i };
    }
  }
  
  return null;
};

const findNextExpectedProcess = (lastProcessIndex) => {
  if (lastProcessIndex === -1) {
    return "A";
  }
  
  for (let i = lastProcessIndex + 1; i < PROCESS_ORDER.length; i++) {
    const processCode = PROCESS_ORDER[i];
    const processConfig = PROCESS_CONFIG[processCode];
    
    if (processCode === "E" || processCode === "L") {
      continue;
    }
    
    if (processConfig.normalDays || processConfig.fastDays) {
      return processCode;
    }
  }
  
  return null;
};

export const formatFechaPedido = (fechaPedido) => {
  if (!fechaPedido) return "N/A";
  
  let date = null;
  if (typeof fechaPedido === "object" && fechaPedido.date) {
    date = new Date(fechaPedido.date);
  } else if (typeof fechaPedido === "string") {
    date = new Date(fechaPedido);
  } else if (fechaPedido instanceof Date) {
    date = fechaPedido;
  }
  
  if (!date || isNaN(date)) return "N/A";
  
  return date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const validateMoProcesses = (mo) => {
  const alerts = [];
  const today = new Date();
  const isFast = isFastOrder(mo);
  
  let orderDate = null;
  if (mo.fechaPedido) {
    if (typeof mo.fechaPedido === "object" && mo.fechaPedido.date) {
      orderDate = new Date(mo.fechaPedido.date);
    } else if (typeof mo.fechaPedido === "string") {
      orderDate = new Date(mo.fechaPedido);
    } else if (mo.fechaPedido instanceof Date) {
      orderDate = mo.fechaPedido;
    }
  }
  
  if (!orderDate || isNaN(orderDate)) {
    return alerts;
  }
  
  const procesos = mo.procesos || [];
  const lastMarkedProcess = findLastMarkedProcess(procesos);
  const nextExpectedProcessCode = findNextExpectedProcess(
    lastMarkedProcess ? lastMarkedProcess.index : -1
  );
  
  if (!nextExpectedProcessCode) {
    return alerts;
  }
  
  const nextProcessConfig = PROCESS_CONFIG[nextExpectedProcessCode];
  const expectedDays = isFast ? nextProcessConfig.fastDays : nextProcessConfig.normalDays;
  const nextProcessDate = getProcessDateFromArray(procesos, nextExpectedProcessCode);
  
  if (nextProcessDate) {
    return alerts;
  }
  
  let referenceDate;
  let referenceProcessCode;
  let daysSinceReference;
  
  if (lastMarkedProcess) {
    referenceDate = lastMarkedProcess.date;
    referenceProcessCode = lastMarkedProcess.processCode;
    daysSinceReference = calculateDaysDifference(referenceDate, today);
  } else {
    referenceDate = orderDate;
    referenceProcessCode = "PEDIDO";
    daysSinceReference = calculateDaysDifference(orderDate, today);
  }
  
  const daysSinceOrder = calculateDaysDifference(orderDate, today);
  let shouldAlert = false;
  
  if (nextExpectedProcessCode === "A") {
    shouldAlert = daysSinceOrder >= expectedDays;
  } else if (nextExpectedProcessCode === "B") {
    shouldAlert = daysSinceReference > 1;
  } else {
    shouldAlert = daysSinceReference >= expectedDays;
  }
  
  if (shouldAlert) {
    alerts.push({
      mo: mo.mo,
      po: mo.po || mo.PO || null,
      cliente: mo.cliente || "N/A",
      fechaPedido: mo.fechaPedido || null,
      fechaEntrega: mo.fechaEntrega || null,
      tipo_orden: mo.tipo_orden || "N/A",
      processCode: nextExpectedProcessCode,
      processName: nextProcessConfig.name,
      days: daysSinceReference,
      daysSinceOrder: daysSinceOrder,
      expectedDays: nextExpectedProcessCode === "B" ? 1 : expectedDays,
      message: `${mo.mo} - ${nextProcessConfig.name}: No tiene fecha registrada. Han pasado ${daysSinceReference} días desde ${referenceProcessCode === "PEDIDO" ? "la fecha del pedido" : PROCESS_CONFIG[referenceProcessCode].name} (${referenceDate.toLocaleDateString()}).`,
    });
  }
  
  return alerts;
};

export const validateMultipleMos = (mosData) => {
  const allAlerts = [];
  
  const mos = Array.isArray(mosData) 
    ? mosData 
    : Object.values(mosData || {});
  
  for (const mo of mos) {
    if (!mo || !mo.mo) continue;
    
    const moAlerts = validateMoProcesses(mo);
    allAlerts.push(...moAlerts);
  }
  
  return allAlerts;
};
